export default __webpack_public_path__ + "static/media/jupyter.b0e5563a.svg";